"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisualisationTitle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = require("../../ui/Icon");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var IconSymbols_1 = require("../../generated/IconSymbols");
var Tooltip_1 = require("../../ui/Tooltip");
var enums_1 = require("../../enums");
var Panel_1 = require("../../ui/Panel");
var VisualisationTitle = function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("visualisation-title").bem;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: props.style, className: "px-3 pt-3 pb-2 ".concat(cls, " ").concat(props.className || "") }, { children: [(0, jsx_runtime_1.jsxs)("h3", __assign({ className: "d-inline-block mb-1" }, { children: [props.title, props.infoContent && ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ shownElement: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { style: { verticalAlign: "middle" }, symbol: IconSymbols_1.IconSymbols.InfoFilled, size: enums_1.UiSizes.SM, className: "visualisation-title__info-icon ml-2" }), triggeredOn: "hover", position: props.infoContentPosition }, { children: (0, jsx_runtime_1.jsx)(Panel_1.Panel, __assign({ className: "p-3", style: { minWidth: "400px" }, background: Panel_1.PanelBackgrounds.BG_WHITE, hasBorderRadius: true, hasShadow: true }, { children: (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: { __html: props.infoContent } }) })) })))] })), props.subtitle && ((0, jsx_runtime_1.jsx)("h4", __assign({ className: "d-inline-block ml-1 mb-1 visualisation-title__subtext" }, { children: props.subtitle })))] })));
};
exports.VisualisationTitle = VisualisationTitle;
